import React, { useEffect, useState } from "react";
import TitleBarComponent from "../../../components/titlebar/TitleBarComponent";
import { getDetailCustomerApi } from "../../../apis/customer.api";
import { ICustomer } from "../../../lib/features/customers/customers.constant";
import { useParams } from "react-router-dom";
import { Image, Spin } from "antd";
import ButtonUpdateCustomer from "./button/ButtonUpdateCustomer";
import CustomerStatisticComponent from "./CustomerStatisticComponent";

const CustomerDetailPage: React.FC = () => {
  const { id } = useParams<{ id: string }>();
  const [loading, setLoading] = useState(false);
  const [customer, setCustomer] = useState<ICustomer | null>(null);
  const [isUpdate, setIsUpdate] = useState(true);
  const handleGetDetailCustomer = async () => {
    if (!id) return;
    setLoading(true);
    try {
      const res = await getDetailCustomerApi(id);
      if (res?.data) {
        setCustomer(res?.data);
      } else {
        setCustomer(null);
      }
    } catch (error) {
      console.error("Error fetching customer detail:", error);
      setCustomer(null);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    handleGetDetailCustomer();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [id, isUpdate]);

  return (
    <div>
      <TitleBarComponent
        title="Chi tiết khách hàng"
        isBack
        reload={handleGetDetailCustomer}
      />

      <div className="bg-white shadow-sm border border-gray-200 rounded-2xl p-6 w-full mt-4">
        {loading ? (
          <div className="flex w-full justify-center items-center min-h-[80%]">
            <Spin />
          </div>
        ) : !customer ? (
          <p className="text-gray-500 text-center">
            Không tìm thấy khách hàng.
          </p>
        ) : (
          <>
            <div className="flex justify-between items-center mb-6">
              <h2 className="text-lg font-semibold text-gray-800">
                Thông tin khách hàng
              </h2>
              <ButtonUpdateCustomer
                update={() => setIsUpdate(!isUpdate)}
                id={id ?? ""}
              />
            </div>

            <div className="grid grid-cols-1 md:grid-cols-2 gap-y-4 gap-x-8 text-gray-700">
              <div>
                <p className="text-sm text-gray-500">Tên gợi nhớ</p>
                <p className="font-medium">{customer?.shortName || "—"}</p>
              </div>{" "}
              <div>
                <p className="text-sm text-gray-500">Họ và tên</p>
                <p className="font-medium">{customer?.fullName || "—"}</p>
              </div>
              <div className="flex justify-between items-center">
                <div>
                  <p className="text-sm text-gray-500">Số điện thoại chính</p>
                  <p className="font-medium">{customer?.majorPhone || "—"}</p>
                </div>
                <a
                  href={`tel:${customer?.majorPhone}`}
                  className="inline-flex items-center justify-center bg-green-500 hover:bg-green-600 text-white font-medium h-10 w-10 rounded-full shadow transition-colors"
                >
                  <i className="fa-solid fa-phone"></i>
                </a>
              </div>
              <div className="flex justify-between items-center">
                <div>
                  <p className="text-sm text-gray-500">Số điện thoại phụ</p>
                  <p className="font-medium">{customer?.minorPhone || "—"}</p>
                </div>
                <a
                  href={`tel:${customer?.minorPhone}`}
                  className="inline-flex items-center justify-center bg-green-500 hover:bg-green-600 text-white font-medium h-10 w-10 rounded-full shadow transition-colors"
                >
                  <i className="fa-solid fa-phone"></i>
                </a>
              </div>
              <div>
                <p className="text-sm text-gray-500">Email</p>
                <p className="font-medium">{customer?.email || "—"}</p>
              </div>
              <div>
                <p className="text-sm text-gray-500">Địa chỉ</p>
                <p className="font-medium">{customer?.address || "—"}</p>
              </div>
              {/* {!!customer?.frontCID && (
                <div>
                  <p className="text-sm text-gray-500">Mặt trước CC</p>
                  <Image
                    width={300}
                    className="mt-3"
                    src={`${customer.frontCID}?t=${Date.now()}`}
                  />
                </div>
              )}
              {!!customer?.backCID && (
                <div>
                  <p className="text-sm text-gray-500">Mặt sau CC</p>
                  <Image
                    width={300}
                    className="mt-3"
                    src={`${customer.backCID}?t=${Date.now()}`}
                  />
                </div>
              )} */}
            </div>
          </>
        )}
      </div>
      <CustomerStatisticComponent id={id ?? ""} />
    </div>
  );
};

export default CustomerDetailPage;
